import {fetchPrices} from '../api/price';
export const LOAD_NETWORKS = 'LOAD_NETWORKS';
export const RECEIVE_NETWORKS = 'RECEIVE_NETWORKS';

export const loadNetworks = () => {
  return {
    type: LOAD_NETWORKS
  }
}

export const receiveNetworks = (json) => {
  return {
    type: RECEIVE_NETWORKS,
    networks: json
  }
}


export const getPrices = () => {
  return (dispatch) => {
    var promise = fetchPrices();
    dispatch(loadNetworks());
    return promise.then((response) => dispatch(receiveNetworks(response)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/PriceCalculator.js